
<template>
  <vs-sidebar click-not-close parent="#tranksaksi-app" :hidden-background="true" class="full-vs-sidebar tranksaksi-view-sidebar items-no-padding" v-model="isPajakActive" position-right>
    <div class="px-0 sm:pb-6 h-full tranksaksi-area-loading">
      <div class="flex flex-wrap items-center justify-between md:px-8 px-6 py-5 d-theme-dark-bg tranksaksi-header bg-primary">
        <h5 class="text-white">Tambah Pajak</h5>
        <feather-icon :icon="$vs.rtl ? 'XIcon' : 'XIcon'" @click="pajakAddClose" class="cursor-pointer mr-4" svg-classes="text-white w-6 h-6"></feather-icon>
      </div>

      <component :is="scrollbarTag" class="tranksaksi-scroll-area md:p-8 p-6 mt-base" :settings="settings" :key="$vs.rtl">

        <div class="vx-col w-full sm:w-3/4 items-center sm:flex-row flex-col mx-auto">
          
          <div class="vx-row mb-6">
            <div class="vx-col w-1/2">
              <vs-input label="Pajak" v-model="dataPajak" class="w-full" name="item-pajak" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('item-pajak')">{{ errors.first('item-pajak') }}</span>
            </div>

            <div class="vx-col w-1/3">
              <vs-input label="Nilai (koma jadi titik)" v-model="dataNilai" class="pr-2 w-full" name="item-nilai" v-validate="'required'"/>

              <span class="text-danger text-sm" v-show="errors.has('item-nilai')">{{ errors.first('item-nilai') }}</span>
            </div>

            <div class="vx-col w-1/6 pt-8">
              Persen
            </div>
          </div>

           <div class="vx-row mt-6">
            <div class="vx-col w-1/2">
              <div class="flex flex-wrap items-center">
                <vs-button class="" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
              </div>
            </div>
            <div class="vx-col w-1/2">
              <div class="flex flex-wrap items-center justify-end">
                <vs-button type="border" color="danger" @click="isPajakActiveLocal = false">Cancel</vs-button>
              </div>
            </div>
           </div>

        </div>
      </component>
    </div>

  </vs-sidebar>

</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import { CurrencyDirective } from 'vue-currency-input'

export default {
  props: {
    isPajakActive: {
      type: Boolean,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar,
    
  },
  directives: {
    currency: CurrencyDirective
  },
  data () {
    return {

      dataId: null,
      dataPajak: null,
      dataGroup: 0,
      dataParent: 0,
      dataNilai: null,

      settings: {
        maxScrollbarLength: 80,
        wheelSpeed: .80
      }
    }
  },
  watch: {
    isPajakActive (val) {
      if (!val) return
      this.initValues()
      this.$validator.reset()
    }
  },
  computed: {
    isPajakActiveLocal: {
      get () {
        return this.isPajakActive
      },
      set (val) {
        if (!val) {
          this.$emit('closePajak')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataPajak && this.dataNilai
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
  },
  mounted(){
  },
  methods: {
    initValues () {
      this.dataId = null
      this.dataPajak = null
      this.dataGroup = 0
      this.dataParent = 0
      this.dataNilai = null
    },
    close() {
      this.$emit('closed', false)
    },
    pajakAddClose() {
      this.$emit('closePajak')
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name: this.dataPajak,
            term_group: this.dataGroup,
            parent: this.dataParent,

            meta : {
              nilai: this.dataNilai.split('.').join(""),
            },

            taxonomy: 'pajak'
          }
          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('pajak/updatePajak', obj)
          } else {
            delete obj.id
            this.$store.dispatch('pajak/addPajak', obj)
          }
          this.$emit('closePajak')
          this.initValues()
        }
      })
    }
  }
}
</script>

